import React from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ServersTab } from "./components/ServersTab";

export const MonitoringSettingsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6 p-4 md:p-8 max-w-[1344px] mx-auto">
      <h1 className="text-2xl font-semibold">
        {t("monitoring.settings.title")}
      </h1>

      <Tabs defaultValue="servers">
        <TabsList>
          <TabsTrigger value="servers">
            {t("monitoring.settings.servers")}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="servers" className="mt-6">
          <ServersTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};
